import { UserStatus } from "@excel-center/shared";
import type { UserRole, UserStatus as UserStatusType } from "@/src/auth/types/auth.types";
import type { RootState } from "@/src/common/redux/store";

const EMPTY_SCHOOL_IDS = Object.freeze([]);

export const selectAuthState = (state: RootState) => state.auth ?? null;

export const selectSession = (state: RootState) => state.auth.session ?? null;

export const selectProfile = (state: RootState) => state.auth.profile ?? null;

export const selectRole = (state: RootState): UserRole | null => (state.auth.profile?.role ?? null) as UserRole | null;

export const selectStatus = (state: RootState): UserStatusType | null => (state.auth.profile?.status ?? null) as UserStatusType | null;

export const selectIsAuthenticated = (state: RootState) => Boolean(state.auth.session);

export const selectIsActive = (state: RootState) => state.auth.profile?.status === UserStatus.ACTIVE;

export const selectIsInitialized = (state: RootState) => state.auth.isInitialized ?? false;

export const selectStaffSchoolIds = (state: RootState) => state.auth.schoolIds ?? EMPTY_SCHOOL_IDS;

export const selectAuthError = (state: RootState) => state.auth.error ?? null;

export const selectIsAuthLoading = (state: RootState) => state.auth.isLoading ?? false;
